module.exports = __webpack_public_path__ + "img/DRESS.aafb5cf1.jpg";